"use client";

import React, { useState } from "react";

const SimilarIds = () => {
  const [idsInput, setIdsInput] = useState("");
  const [brand, setBrand] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // split by comma or newline
    const itemIds = idsInput
      .split(/[\n,]+/)
      .map((id) => id.trim())
      .filter(Boolean);

    if (itemIds.length < 2) {
      alert("Enter at least 2 IDs");
      return;
    }

    try {
      setLoading(true);

      const res = await fetch("https://api.malidag.com/api/similar-items", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          itemIds,
          brand: brand.trim() || null,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.error || "Failed to save");
        return;
      }

      alert("✅ Similar items saved successfully");

      // reset
      setIdsInput("");
      setBrand("");
    } catch (err) {
      console.error(err);
      alert("Error saving similar items");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20, maxWidth: 600 }}>
      <h2 style={{ fontSize: 22, fontWeight: "bold", marginBottom: 10 }}>
        Similar Items
      </h2>

      <form onSubmit={handleSubmit}>
        <textarea
          placeholder="Enter item IDs (comma or new line separated)"
          value={idsInput}
          onChange={(e) => setIdsInput(e.target.value)}
          style={{
            width: "100%",
            height: 120,
            padding: 10,
            border: "1px solid #ccc",
            marginBottom: 10,
          }}
        />

        <input
          type="text"
          placeholder="Brand (optional)"
          value={brand}
          onChange={(e) => setBrand(e.target.value)}
          style={{
            width: "100%",
            padding: 10,
            border: "1px solid #ccc",
            marginBottom: 10,
          }}
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            padding: "10px 16px",
            background: "#0f172a",
            color: "#fff",
            border: "none",
            cursor: "pointer",
          }}
        >
          {loading ? "Saving..." : "Save Similar Items"}
        </button>
      </form>
    </div>
  );
};

export default SimilarIds;